import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import s from './mobile-settings.module.scss'
import { useEffect } from 'react';
import { IconChevronLeft } from '@tabler/icons-react';

export const MobileSettings = () => {
	const navigate = useNavigate()

	useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        navigate('settings');
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [navigate]);

	return (
		<div className={s.wrapper}>
			<NavLink to="/settings" className={s.back}>
				<IconChevronLeft size={16} />
				Назад
			</NavLink>
			<Outlet/>
		</div>
	)
}
